import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModuleBreastEndocrineSurgery from '../../schemas/module-breast-endocrine-surgery.json';

export class SchemaModuleBreastEndocrineSurgery extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleBreastEndocrineSurgery );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-breast-endocrine-surgery.ts